import React, { useRef } from 'react'
import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'
import { Trans } from 'react-i18next'
import { Link } from '@fs/zion-router'
import { baseUrl } from '@fs/zion-config'

const VIEW_TREE_URL = `${baseUrl}/tree/pedigree/portrait`

const PrintDialog = ({ printOverlay }) => {
  const focusRef = useRef()

  return (
    <DialogOverlay
      {...printOverlay}
      closeOnClickAway
      focusRef={focusRef}
      title={i18n.t('PrintDialog.DialogOverlay.title', 'Continue to build and preserve your Family Tree.')}
    >
      <section>
        <p>
          <Trans
            components={[
              <Link key="treeURL" external target="_self" to={VIEW_TREE_URL} />,
              <Link key="baseURL" external target="_self" to={baseUrl} />,
            ]}
            defaults="You can view this <0>family tree</0>, which allows you to continue adding and preserving more family members and their information such as birth and death date, at any time on <1>FamilySearch</1>."
            i18nKey="PrintDialog.DialogOverlay.message"
          />
        </p>
      </section>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={printOverlay.close}>{i18n.t('common-ui:close.action', 'close')}</Button>
          <Button ref={focusRef} emphasis="high" to={VIEW_TREE_URL}>
            {i18n.t('PrintDialog.DialogOverlayActions.goToTree', 'Go to Family Tree')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}

export default PrintDialog
